import React, { useState } from 'react';
import { InputCheckbox, InputNoForm, StyledInputCheckbox } from '../../../components/TextInput';
import { Box, Flex, Text } from 'rebass';
import theme from '../../../styles/theme';
import { AiIcon } from '../HpisWrapper';

type Props = {
  talkingPoints?: string;
  recommendations?: string;
  talkingPointsReasoning?: Array<string>,
  recommendationsReasoning?: Array<string>
};

const ParseHtmlToReact = (htmlString: string, showReasoning?: boolean, reasonings?: Array<string>) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const ul = doc.querySelector('ul');
  const [checked, setChecked] = useState<Array<string>>([])

  if (!ul) return null;

  const listItems = Array.from(ul.querySelectorAll('li'));

  return (
    <ul style={{ paddingLeft: 0, marginBottom: 16 }}>
      {listItems.map((li, index) => {
        const spans = Array.from(li.childNodes).map((node, i) => {
          if (node.nodeType === Node.TEXT_NODE) {
            return <React.Fragment key={i}>{node.textContent}</React.Fragment>;
          }

          if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node as HTMLElement;
            if (el.tagName === 'SPAN') {
              const styleRaw: Record<string, string> = {};
              el.getAttribute('style')?.split(';').forEach(rule => {
                const [key, value] = rule.split(':').map(s => s.trim());
                if (key && value) {
                  styleRaw[key] = value;
                }
              });

              if (
                styleRaw['background'] === 'rgb(159, 140, 23)' ||
                styleRaw['background-color'] === 'rgb(159, 140, 23)' ||

                styleRaw['background'] === '#9f8c17' ||
                styleRaw['background-color'] === '#9f8c17'
              ) {
                styleRaw['background'] = '#5f7497'; // your desired background
                styleRaw['padding-left'] = '3px'; // your desired background
                styleRaw['padding-right'] = '3px'; // your desired background
              }
              const style = styleRaw as React.CSSProperties;

              return (
                <span key={i} style={style}>
                  {el.textContent}
                </span>
              );
            }
          }

          return null;
        });

        // Extract li-level styles
        // const liStyle: React.CSSProperties = {};
        const liStyleRaw: Record<string, string> = {};
        li.getAttribute('style')?.split(';').forEach(rule => {
          const [key, value] = rule.split(':').map(s => s.trim());
          if (key && value) {
            liStyleRaw[key] = value;
          }
        });
        const liStyle = liStyleRaw as React.CSSProperties;
        const isChecked = checked.indexOf(index.toString()) > -1
        let reasoning
        if (reasonings && !!showReasoning && index <= (reasonings || [])?.length - 1) {
          reasoning = reasonings[index]
        }
        return (
          <Flex flexDirection={'column'}>
            <li key={index} style={{ ...liStyle, listStyle: 'none', marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                <Flex alignItems={'center'} justifyContent={'center'} style={{ cursor: 'pointer', width: '16px', height: '16px', background: isChecked ? theme.color.primary : 'white', marginTop: '2px', border: `1px solid ${theme.color.primary}`, borderRadius: '3px' }} onClick={() => {
                  if (isChecked) {
                    setChecked(checked.filter(x => x !== index.toString()))
                  } else {
                    setChecked([...checked, index.toString()])
                  }
                }}>
                  {isChecked ? <Text style={{ color: 'white' }}>✔</Text> : null}
                </Flex>
                <div style={{ textDecoration: isChecked ? 'line-through' : '', flex: 1, color: theme.color.primary }}>{spans}</div>
              </div>
            </li>
            {!!reasoning && (
              <Flex pl={4} mb={3} style={{ color: '#ca7e74' }} alignItems={'center'}>
                <svg width="22" height="22" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.72916 3.08276L6.92516 4.8842L9.60938 7.56714L11.4108 5.7657L8.72787 3.08276H8.72916ZM32.2721 3.08276L29.5879 5.7657L31.3906 7.56714L34.0736 4.88548L32.2708 3.08276H32.2721ZM20.5 3.88226C20.0772 3.88739 19.6493 3.91173 19.2188 3.96426C19.2059 3.96426 19.1931 3.9617 19.1803 3.96426C13.9836 4.56005 9.84769 8.7587 9.12891 13.9324C8.55491 18.0965 10.2718 21.8723 13.1328 24.3041C14.3031 25.3029 15.0947 26.6735 15.375 28.1863V35.8738H18.2962C18.7421 36.6387 19.5557 37.155 20.5 37.155C21.4443 37.155 22.2579 36.6387 22.7037 35.8738H25.625V30.7488H25.7454V29.2267C25.7454 27.3484 26.7218 25.4547 28.3079 23.9825C30.4297 21.8582 32.0312 18.8409 32.0312 15.3751C32.0312 9.0457 26.8217 3.82333 20.5 3.88226ZM20.5 6.44476C25.452 6.37558 29.4688 10.4295 29.4688 15.3751C29.4688 18.058 28.2259 20.4206 26.5052 22.1401L26.5462 22.1811C24.8362 23.7579 23.7305 25.8824 23.42 28.1876H17.8158C17.5339 25.9915 16.5922 23.8659 14.8125 22.3412C12.5486 20.4194 11.1994 17.5237 11.6504 14.254C12.2103 10.218 15.4852 6.97264 19.4981 6.52804C19.8294 6.48185 20.163 6.45448 20.4974 6.44605L20.5 6.44476ZM2.5625 15.3751V17.9376H6.40625V15.3751H2.5625ZM34.5938 15.3751V17.9376H38.4375V15.3751H34.5938ZM9.60938 25.7455L6.92644 28.4272L8.72916 30.2299L11.4095 27.547L9.60938 25.7455ZM31.3906 25.7455L29.5892 27.547L32.2708 30.2299L34.0736 28.4272L31.3906 25.7455ZM17.9375 30.7501H23.0625V33.3126H17.9375V30.7501Z" fill="#ffa295" />
                </svg>
                <div style={{ flex: 1, marginLeft: 12 }} dangerouslySetInnerHTML={{ __html: reasoning }} />
              </Flex>
            )}
          </Flex>
        );
      })}
    </ul>
  );
};

const AiFormattedContent: React.FC<Props> = ({ talkingPoints, recommendations, talkingPointsReasoning, recommendationsReasoning }) => {
  const [showTalkingPointsReasoning, setShowTalkingPointsReasoning] = useState(false)
  const [showRecommendationsReasoning, setShowRecommendationsReasoning] = useState(false)
  return (
    <Flex flexDirection={'column'} style={{ fontSize: '14px', lineHeight: 1.6 }}>
      {talkingPoints && (
        <>
          <Flex mb={'8px'} justifyContent={'space-between'} alignItems={'center'}>
            <Flex style={{ gap: '12px' }}>
              <Text style={{ fontWeight: 600, fontSize: 16 }}>
                Talking points:
              </Text>
              <AiIcon />
            </Flex>
            <Flex onClick={() => setShowTalkingPointsReasoning(!showTalkingPointsReasoning)} alignItems={'center'} style={{ gap: '6px', cursor: 'pointer' }}>
              <svg width="22" height="22" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.72916 3.08276L6.92516 4.8842L9.60938 7.56714L11.4108 5.7657L8.72787 3.08276H8.72916ZM32.2721 3.08276L29.5879 5.7657L31.3906 7.56714L34.0736 4.88548L32.2708 3.08276H32.2721ZM20.5 3.88226C20.0772 3.88739 19.6493 3.91173 19.2188 3.96426C19.2059 3.96426 19.1931 3.9617 19.1803 3.96426C13.9836 4.56005 9.84769 8.7587 9.12891 13.9324C8.55491 18.0965 10.2718 21.8723 13.1328 24.3041C14.3031 25.3029 15.0947 26.6735 15.375 28.1863V35.8738H18.2962C18.7421 36.6387 19.5557 37.155 20.5 37.155C21.4443 37.155 22.2579 36.6387 22.7037 35.8738H25.625V30.7488H25.7454V29.2267C25.7454 27.3484 26.7218 25.4547 28.3079 23.9825C30.4297 21.8582 32.0312 18.8409 32.0312 15.3751C32.0312 9.0457 26.8217 3.82333 20.5 3.88226ZM20.5 6.44476C25.452 6.37558 29.4688 10.4295 29.4688 15.3751C29.4688 18.058 28.2259 20.4206 26.5052 22.1401L26.5462 22.1811C24.8362 23.7579 23.7305 25.8824 23.42 28.1876H17.8158C17.5339 25.9915 16.5922 23.8659 14.8125 22.3412C12.5486 20.4194 11.1994 17.5237 11.6504 14.254C12.2103 10.218 15.4852 6.97264 19.4981 6.52804C19.8294 6.48185 20.163 6.45448 20.4974 6.44605L20.5 6.44476ZM2.5625 15.3751V17.9376H6.40625V15.3751H2.5625ZM34.5938 15.3751V17.9376H38.4375V15.3751H34.5938ZM9.60938 25.7455L6.92644 28.4272L8.72916 30.2299L11.4095 27.547L9.60938 25.7455ZM31.3906 25.7455L29.5892 27.547L32.2708 30.2299L34.0736 28.4272L31.3906 25.7455ZM17.9375 30.7501H23.0625V33.3126H17.9375V30.7501Z" fill="#ffa295" />
              </svg>
              <Text style={{ color: '#ffa295', textDecoration: 'underline', fontWeight: 500 }}>{!showTalkingPointsReasoning ? 'View' : 'Hide'} Reasoning</Text>
            </Flex>
          </Flex>
          {ParseHtmlToReact(talkingPoints, showTalkingPointsReasoning, talkingPointsReasoning)}
        </>
      )}

      {recommendations && (
        <>
          <Flex mt={'24px'} mb={'8px'} justifyContent={'space-between'} alignItems={'center'}>
            <Flex style={{ gap: '12px' }}>
              <Text style={{ fontWeight: 600, fontSize: 16 }}>
                Recommendations:
              </Text>
              <AiIcon />
            </Flex>
            <Flex onClick={() => setShowRecommendationsReasoning(!showRecommendationsReasoning)} alignItems={'center'} style={{ gap: '6px', cursor: 'pointer' }}>
              <svg width="22" height="22" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.72916 3.08276L6.92516 4.8842L9.60938 7.56714L11.4108 5.7657L8.72787 3.08276H8.72916ZM32.2721 3.08276L29.5879 5.7657L31.3906 7.56714L34.0736 4.88548L32.2708 3.08276H32.2721ZM20.5 3.88226C20.0772 3.88739 19.6493 3.91173 19.2188 3.96426C19.2059 3.96426 19.1931 3.9617 19.1803 3.96426C13.9836 4.56005 9.84769 8.7587 9.12891 13.9324C8.55491 18.0965 10.2718 21.8723 13.1328 24.3041C14.3031 25.3029 15.0947 26.6735 15.375 28.1863V35.8738H18.2962C18.7421 36.6387 19.5557 37.155 20.5 37.155C21.4443 37.155 22.2579 36.6387 22.7037 35.8738H25.625V30.7488H25.7454V29.2267C25.7454 27.3484 26.7218 25.4547 28.3079 23.9825C30.4297 21.8582 32.0312 18.8409 32.0312 15.3751C32.0312 9.0457 26.8217 3.82333 20.5 3.88226ZM20.5 6.44476C25.452 6.37558 29.4688 10.4295 29.4688 15.3751C29.4688 18.058 28.2259 20.4206 26.5052 22.1401L26.5462 22.1811C24.8362 23.7579 23.7305 25.8824 23.42 28.1876H17.8158C17.5339 25.9915 16.5922 23.8659 14.8125 22.3412C12.5486 20.4194 11.1994 17.5237 11.6504 14.254C12.2103 10.218 15.4852 6.97264 19.4981 6.52804C19.8294 6.48185 20.163 6.45448 20.4974 6.44605L20.5 6.44476ZM2.5625 15.3751V17.9376H6.40625V15.3751H2.5625ZM34.5938 15.3751V17.9376H38.4375V15.3751H34.5938ZM9.60938 25.7455L6.92644 28.4272L8.72916 30.2299L11.4095 27.547L9.60938 25.7455ZM31.3906 25.7455L29.5892 27.547L32.2708 30.2299L34.0736 28.4272L31.3906 25.7455ZM17.9375 30.7501H23.0625V33.3126H17.9375V30.7501Z" fill="#ffa295" />
              </svg>
              <Text style={{ color: '#ffa295', textDecoration: 'underline', fontWeight: 500 }}>{!showRecommendationsReasoning ? 'View' : 'Hide'} Reasoning</Text>
            </Flex>
          </Flex>
          {ParseHtmlToReact(recommendations, showRecommendationsReasoning, recommendationsReasoning)}
        </>
      )}
    </Flex >
  );
};

export default AiFormattedContent